// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"fade-in_fadeIn__BWXVO","shown":"fade-in_shown__q0W3P"};